import {
  type BarChartProps,
  type LineChartProps,
  BarChart as NivoBarChart,
  LineChart as NivoLineChart,
  PieChart as NivoPieChart,
  type PieChartProps,
} from "@hoylu/nivo-charts";
import React, { memo } from "react";

//This memoization is required due to Chart component state changes, that handles isLoaded and fetch / no data scenarios.
//If we don't memoize this component, it will re-render on every state change in parent component overloading rendering process resulting in glitches.
export const LineChart = memo((props: LineChartProps) => {
  return <NivoLineChart {...props} />;
});

export const PieChart = memo((props: PieChartProps) => {
  return <NivoPieChart {...props} />;
});

export const BarChart = memo((props: BarChartProps) => {
  return <NivoBarChart {...props} />;
});
